// SUP-389 — workspace-scoped weekly content reports.
//
// Weekly content reports are scoped to the active workspace; the
// historical per-profile analytics flag only widens results and is no
// longer used as a gate on the FE. The legacy v1 endpoints
// for connecting / listing / deleting analytics profiles, and for
// per-profile weekly-report fetches, were removed in this cleanup
// once their last consumers (the dead analytics-connect modal and
// the dashboard banner's per-profile loop) were retired.

export const ANALYTICS_LAST_TARGET_STORAGE_KEY = "sg_analytics_last_target";
export const ANALYTICS_LAST_TARGET_CHANGED_EVENT = "sg:analytics-last-target-changed";

export const buildWeeklyReportTargetKey = (target) => {
  if (!target) return "none";
  if (target.type === "company_page") return `company_page:${target.page_id || target.id || ""}`;
  return `profile:${target.user_id || ""}`;
};

const buildWeeklyReportTargetParams = (target) => {
  if (!target) return {};

  if (target.type === "company_page") {
    const pageId = target.page_id || target.id;
    return pageId ? { linked_in_company_page_id: pageId } : {};
  }

  return target.user_id ? { linked_in_account_id: target.user_id } : {};
};

export const createGetWorkspaceWeeklyReportsListRequest = (limit = 12, target = null) => {
  return {
    url: "/analytics/weekly_reports",
    method: "GET",
    params: { limit, ...buildWeeklyReportTargetParams(target) },
  };
};

export const createGetWorkspaceWeeklyReportRequest = (week, target = null) => {
  // GET /analytics/weekly_reports/:week — week (a YYYY-MM-DD start date)
  // is a required path parameter so the single-report URL nests under
  // the collection cleanly without colliding with the list endpoint.
  const targetParams = buildWeeklyReportTargetParams(target);
  const request = {
    url: `/analytics/weekly_reports/${week}`,
    method: "GET",
  };

  if (Object.keys(targetParams).length > 0) {
    request.params = targetParams;
  }

  return request;
};
